import { render, staticRenderFns } from "./NavigationHeader.vue?vue&type=template&id=0a4e98fa&"
import script from "./NavigationHeader.vue?vue&type=script&lang=ts&"
export * from "./NavigationHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports